import { ChildrenProp } from "../../types/common";
import { UserAgentContext } from "./UserAgentContext";

export function UserAgentProvider({ children }: ChildrenProp) {
  const MOBILE_MAX_WIDTH = 905;

  const isDesktop = window.innerWidth > MOBILE_MAX_WIDTH;

  return <UserAgentContext.Provider value={{ isDesktop }}>{children}</UserAgentContext.Provider>;
}
